import {ErrorHandler} from '@angular/core';
import * as Raven from 'raven-js';
import {environment} from '../../../../../environments/environment';

export class RavenErrorHandler implements ErrorHandler {

  public handleError(err: any): void {
    console.error(err);
    if (typeof err.originalError !== 'undefined') {
      this.captureException(err.originalError);
    } else {
      this.captureException(err);
    }
  }

  private captureException(err: any) {
    if (!environment.production)
      return;
    Raven.captureException(err);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/modules/sentry/raven-error.handler.ts